import { observable } from 'mobx'

import Store from '../shared/store'
import { apiStore, FileUploadMiddleware } from '../shared/api'
import { apiClient } from '../shared/api-impl'

import { guidedTour as config } from '../config'

import GuidedTour from './model'

@apiStore(apiClient, [
  new FileUploadMiddleware({
    attrKeys: [
      { key: 'links', fieldName: 'pdf' },
      { key: 'images', fieldName: 'image' }
    ],
    // type: 'image'
  })
])
class GuidedTourStore extends Store {

  @observable loading = false

  @observable collection = []

  @observable filterCollection = []

  @observable current = null

  constructor(opts = {}) {

    super(opts)

    this.Model = GuidedTour

    this.initAPIStore({
      ...opts,
      api: config.api,
    })

  }

  createModel(data = {}) {
    const draft = {}
    // try {
    //   draft = JSON.parse(localStorage.guidedTourDraft)
    // }
    // catch (ex) {
    //   draft = {}
    // }
    return super.createModel({
      ...draft,
      ...data
    })
  }

  loadPublic(id, opts = {}, data = null) {
    opts.action = 'loadPublic'
    return this.api.load(id, opts, data)
  }

  load(...args) {
    return this.api.load(...args)
  }

  save(...args) {
    return this.api.save(...args)
  }

  destroy(...args) {
    return this.api.destroy(...args)
  }

}

export default GuidedTourStore



// WEBPACK FOOTER //
// ./src/guided-tour/store.js